const moduleMap = {
	"./globalApiMessageSlice": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("src_redux_features_globalApiMessageSlice_js")]).then(() => (() => ((__webpack_require__(13947)))));
	},
	"./notificationSlice": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios-webpack_sharing_consume_default_jwt-decode_jwt-decode"), __webpack_require__.e("webpack_sharing_consume_default_lodash_lodash"), __webpack_require__.e("src_redux_features_notificationSlice_js")]).then(() => (() => ((__webpack_require__(92438)))));
	},
	"./loginSlice": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios-webpack_sharing_consume_default_jwt-decode_jwt-decode"), __webpack_require__.e("src_redux_features_loginSlice_js")]).then(() => (() => ((__webpack_require__(68852)))));
	},
	"./landingSliceIndex": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios-webpack_sharing_consume_default_jwt-decode_jwt-decode"), __webpack_require__.e("src_redux_features_landingSlice_js")]).then(() => (() => ((__webpack_require__(24058)))));
	},
	"./globalLoading": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("src_redux_features_loading_js")]).then(() => (() => ((__webpack_require__(1169)))));
	},
	"./DefaultImg": () => {
		return __webpack_require__.e("src_assets_default_images_placeholder_jpg").then(() => (() => ((__webpack_require__(37286)))));
	},
	"./utils": () => {
		return __webpack_require__.e("src_assets_utils_js").then(() => (() => ((__webpack_require__(91861)))));
	},
	"./LoadingSpinner": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_components_LoadingSpinner_index_js")]).then(() => (() => ((__webpack_require__(91135)))));
	},
	"./ProgressiveImage": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_components_ProgressiveImage_index_js")]).then(() => (() => ((__webpack_require__(49318)))));
	},
	"./dynamicLabels": () => {
		return __webpack_require__.e("src_utils_dynamicLabels_js").then(() => (() => ((__webpack_require__(3608)))));
	},
	"./useLogout": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios-webpack_sharing_consume_default_jwt-decode_jwt-decode"), __webpack_require__.e("webpack_container_remote_CHECKOUT_HcpSlice-webpack_container_remote_CHECKOUT_addressSlice"), __webpack_require__.e("src_utils_useLogout_js")]).then(() => (() => ((__webpack_require__(80372)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});